import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaCheck } from "react-icons/fa";

export default function DropdownSelect({ value, onChange, options, label, icon: Icon, height = "56px" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative", minWidth: "180px" }}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-4 w-full"
        style={{ height, cursor: "pointer", outline: "none", justifyContent: "space-between" }}
      >
        <div className="flex items-center gap-2">
          {Icon && <Icon style={{ color: "#6b7280", fontSize: "12px", flexShrink: 0 }} />}
          <span className="text-sm text-gray-500 whitespace-nowrap">{label}:</span>
          <span className="text-sm font-semibold text-gray-800 truncate" style={{ maxWidth: "120px" }}>
            {value}
          </span>
        </div>
        <FaChevronDown
          style={{
            color: "#6b7280",
            fontSize: "11px",
            flexShrink: 0,
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </button>

      {open && (
        <div
          className="absolute z-50 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden"
          style={{ top: "calc(100% + 6px)", left: 0, right: 0, minWidth: "100%" }}
        >
          {options.map((opt) => (
            <button
              key={opt}
              onClick={() => { onChange(opt); setOpen(false); }}
              className="w-full flex items-center justify-between px-4 py-3 text-sm text-left"
              style={{
                background: opt === value ? "#f0fdf4" : "transparent",
                color: opt === value ? "#006B3F" : "#374151",
                fontWeight: opt === value ? 600 : 400,
                cursor: "pointer",
                border: "none",
                borderBottom: "1px solid #f3f4f6",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) => { if (opt !== value) e.currentTarget.style.background = "#f9fafb"; }}
              onMouseLeave={(e) => { if (opt !== value) e.currentTarget.style.background = "transparent"; }}
            >
              {opt}
              {opt === value && <FaCheck style={{ fontSize: "11px", color: "#006B3F" }} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
